<template>
  <div class="app-container">
    软件需求管理
    <!-- <list ref="list">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canWrite()" type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <details-dialog ref="detailsDialog" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/bm/requirement/list";
import detailsDialog from "@/components/bm/requirement/details";

export default {
  name: "requirement",
  // mixins: [curdMixins],
  components: {
    list,
    detailsDialog,
  },
  data() {
    return {
      LoginId: "",
      Keyword: "",
      Res: null,
    };
  },
  methods: {
    details(row) {
      this.$refs.detailsDialog.openDetailsById(row.RequirementId);
    },
  },
};
</script>